export class SignageDisplayOrderModel {
    public id: number;
    public displayOrder: number;
}
